import {library} from '@fortawesome/fontawesome-svg-core';
import {
   faCircle as farCircle,
   faFaceSmile as farFaceSmile,
   faFlag as farFlag,
   faHeart as farHeart,
   faBell as farBell,
   faSquare as farSquare,
   faStar as farStar,
   faThumbsUp as farThumbsUp,
} from '@fortawesome/pro-regular-svg-icons';
import {
   faAlignLeft as fasAlignLeft,
   faAnglesLeft as fasAnglesLeft,
   faAnglesRight as fasAnglesRight,
   faArrowDown as fasArrowDown,
   faAt as fasAt,
   faArrowDownWideShort as fasArrowDownWideShort,
   faArrowLeft as fasArrowLeft,
   faArrowRight as fasArrowRight,
   faArrowUp as fasArrowUp,
   faArrowsRotate as fasArrowsRotate,
   faArrowsUpDown as fasArrowsUpDown,
   faBackwardStep as fasBackwardStep,
   faBan as fasBan,
   faBars as fasBars,
   faBell as fasBell,
   faBolt as fasBolt,
   faBoxArchive as fasBoxArchive,
   faBuilding as fasBuilding,
   faCalendar as fasCalendar,
   faCalendarDays as fasCalendarDays,
   faCaretDown as fasCaretDown,
   faCaretRight as fasCaretRight,
   faCheck as fasCheck,
   faChevronDown as fasChevronDown,
   faChevronLeft as fasChevronLeft,
   faChevronRight as fasChevronRight,
   faChevronUp as fasChevronUp,
   faCircle as fasCircle,
   faCircleCheck as fasCircleCheck,
   faCircleExclamation as fasCircleExclamation,
   faCircleHalfStroke as fasCircleHalfStroke,
   faCircleInfo as fasCircleInfo,
   faCircleXmark as fasCircleXmark,
   faClock as fasClock,
   faCloudArrowUp as fasCloudArrowUp,
   faCode as fasCode,
   faCompress as fasCompress,
   faCopy as fasCopy,
   faCreditCard as fasCreditCard,
   faCubes as fasCubes,
   faDeleteLeft as fasDeleteLeft,
   faDesktop as fasDesktop,
   faEllipsisVertical as fasEllipsisVertical,
   faEnvelope as fasEnvelope,
   faEnvelopeCircleCheck as fasEnvelopeCircleCheck,
   faEnvelopeOpenText as fasEnvelopeOpenText,
   faExclamation as fasExclamation,
   faEye as fasEye,
   faEyeDropper as fasEyeDropper,
   faEyeSlash as fasEyeSlash,
   faFilter as fasFilter,
   faFlag as fasFlag,
   faFolder as fasFolder,
   faFolderPlus as fasFolderPlus,
   faFont as fasFont,
   faForwardStep as fasForwardStep,
   faGear as fasGear,
   faHashtag as fasHashtag,
   faHeading as fasHeading,
   faHeart as fasHeart,
   faIcons as fasIcons,
   faKey as fasKey,
   faKeyboard as fasKeyboard,
   faLayerGroup as fasLayerGroup,
   faLink as fasLink,
   faListUl as fasListUl,
   faLock as fasLock,
   faMagnifyingGlass as fasMagnifyingGlass,
   faMinus as fasMinus,
   faMobileScreen as fasMobileScreen,
   faPalette as fasPalette,
   faPaperPlane as fasPaperPlane,
   faPaperclip as fasPaperclip,
   faPause as fasPause,
   faPenToSquare as fasPenToSquare,
   faPhone as fasPhone,
   faPlay as fasPlay,
   faPlus as fasPlus,
   faPuzzlePiece as fasPuzzlePiece,
   faReply as fasReply,
   faRightFromBracket as fasRightFromBracket,
   faRightToBracket as fasRightToBracket,
   faRobot as fasRobot,
   faRotate as fasRotate,
   faSatelliteDish as fasSatelliteDish,
   faShapes as fasShapes,
   faShieldHalved as fasShieldHalved,
   faSliders as fasSliders,
   faSquare as fasSquare,
   faSquareCheck as fasSquareCheck,
   faSquareMinus as fasSquareMinus,
   faStar as fasStar,
   faStarHalf as fasStarHalf,
   faFileExport as fasFileExport,
   faTableColumns as fasTableColumns,
   faTableList as fasTableList,
   faTag as fasTag,
   faThumbsUp as fasThumbsUp,
   faToggleOff as fasToggleOff,
   faToggleOn as fasToggleOn,
   faTrash as fasTrash,
   faTriangleExclamation as fasTriangleExclamation,
   faUser as fasUser,
   faUserPlus as fasUserPlus,
   faUserSecret as fasUserSecret,
   faUserSlash as fasUserSlash,
   faUsers as fasUsers,
   faUsersGear as fasUsersGear,
   faVolumeHigh as fasVolumeHigh,
   faVolumeLow as fasVolumeLow,
   faVolumeOff as fasVolumeOff,
   faClone as fasClone,
   faComment as fasComment,
   faCompass as fasCompass,
   faFaceSmile as fasFaceSmile,
   faImage as fasImage,
   faPen as fasPen,
   faPlug as fasPlug,
   faUserCheck as fasUserCheck,
   faUserGear as fasUserGear,
   faWandMagicSparkles as fasWandMagicSparkles,
   faXmark as fasXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
   FontAwesomeIcon,
   FontAwesomeLayers,
   FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import type {Component, createApp} from 'vue';

/**
 * Font Awesome setup for the main app. Register icons one by one, never a
 * whole pack; a new icon used in a template is imported here and added to
 * `library.add(...)`.
 *
 * Icons are keyed by style prefix: pro-solid is `fas`, pro-regular is `far`,
 * pro-light `fal`, pro-thin `fat`, brands `fab`; sharp and duotone packs are
 * also installed (`fass`, `fad`, …). Imports are aliased with the prefix
 * (`faStar as fasStar`) so the list reads like the template strings. Templates
 * always write the prefix ("fas fa-star"); a bare "fa fa-star" silently means
 * solid. Pro packages come from npm.fontawesome.com; the auth token lives in
 * the developer's ~/.npmrc, not in the repo.
 */
export function setupFontawesome(app: ReturnType<typeof createApp>): void {
   library.add(
      // General actions / status (fasCircleInfo/fasExclamation back the Vuetify
      // $info/$warning aliases used by v-alert type icons)
      fasArrowDown,
      fasArrowRight,
      fasArrowUp,
      fasArrowsRotate,
      fasArrowsUpDown,
      fasBackwardStep,
      fasCalendar,
      fasCaretDown,
      fasCaretRight,
      fasChevronUp,
      fasCircle,
      fasCircleXmark,
      fasCloudArrowUp,
      fasCompress,
      fasDeleteLeft,
      fasEnvelopeOpenText,
      fasEyeDropper,
      fasFolder,
      fasFolderPlus,
      fasForwardStep,
      fasKeyboard,
      fasMinus,
      fasPaperclip,
      fasPause,
      fasPenToSquare,
      fasPlay,
      fasPlus,
      fasReply,
      fasRotate,
      fasCheck,
      fasCircleCheck,
      fasCircleExclamation,
      fasCircleInfo,
      fasExclamation,
      // App chrome (board header, drawers, theme toggle)
      fasBars,
      fasBell,
      fasCircleHalfStroke,
      fasAnglesLeft,
      fasAnglesRight,
      fasChevronDown,
      fasChevronLeft,
      fasChevronRight,
      fasMagnifyingGlass,
      fasArrowLeft,
      // Settings area
      fasSquare,
      fasStarHalf,
      fasUser,
      fasUserSlash,
      fasUsers,
      fasSliders,
      fasShapes,
      fasShieldHalved,
      fasCreditCard,
      fasSatelliteDish,
      fasTrash,
      // Auth flows + account security + admin area
      fasLock,
      fasKey,
      fasEnvelope,
      fasEnvelopeCircleCheck,
      fasRightToBracket,
      fasRightFromBracket,
      fasUserCheck,
      fasUserPlus,
      fasUserSecret,
      fasUsersGear,
      fasBan,
      fasCopy,
      fasEye,
      fasDesktop,
      fasMobileScreen,
      fasTriangleExclamation,
      fasPaperPlane,
      fasRobot,
      fasEllipsisVertical,
      fasBuilding,
      fasClock,
      // Board page (header, toolbar, cards)
      fasStar,
      farStar,
      fasGear,
      fasFilter,
      fasArrowDownWideShort,
      fasEyeSlash,
      fasLayerGroup,
      fasVolumeHigh,
      fasVolumeLow,
      fasVolumeOff,
      fasXmark,
   fasAlignLeft,
   fasClone,
   fasComment,
   fasCompass,
   fasFaceSmile,
   fasImage,
   fasPen,
   fasPlug,
   fasUserGear,
   fasWandMagicSparkles,
   farBell,
   farFaceSmile,
   fasAt,
      // Board settings panel sections
      fasTag,
      fasListUl,
      fasBolt,
      fasPuzzlePiece,
      fasBoxArchive,
      // Dev area (development builds only, but registration is cheap)
      fasPalette,
      fasCubes,
      fasCode,
      fasIcons,
      // Vuetify checkbox aliases ($checkboxOn/Off/Indeterminate → fa strings)
      fasSquareCheck,
      fasSquareMinus,
      farSquare,
      // Card fields: type chips, value badges, checkbox and rating glyphs
      fasCalendarDays,
      fasFlag,
      farFlag,
      fasFont,
      fasHashtag,
      fasHeading,
      fasHeart,
      farHeart,
      fasLink,
      fasPhone,
      fasFileExport,
      fasTableColumns,
      fasTableList,
      fasThumbsUp,
      farThumbsUp,
      fasToggleOff,
      fasToggleOn,
      farCircle,
   );

   // Cast to Component — the generic FA component type is too complex for
   // TS to represent when passed to app.component() directly.
   app.component('font-awesome-icon', FontAwesomeIcon as Component);
   app.component('FontAwesomeLayers', FontAwesomeLayers as Component);
   app.component('FontAwesomeLayersText', FontAwesomeLayersText as Component);
}
